
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M19.983 2a18 18 0 10.033 0zM20 34.4A14.4 14.4 0 1134.4 20 14.4 14.4 0 0120 34.4z"}}),_c('path',{attrs:{"d":"M26.483 27.517a1.707 1.707 0 01-1.183-.483 7.407 7.407 0 00-2.383-1.6 7.509 7.509 0 00-8.217 1.6 1.662 1.662 0 11-2.35-2.35 10.745 10.745 0 013.45-2.317 10.884 10.884 0 018.433 0 11.216 11.216 0 013.45 2.317 1.66 1.66 0 010 2.35 1.777 1.777 0 01-1.2.483zm.584-9.051a3.918 3.918 0 001.433-5.333l-6.75 3.9a3.88 3.88 0 005.317 1.433zm-14.134 0a3.9 3.9 0 005.333-1.433l-6.75-3.9a3.9 3.9 0 001.417 5.333z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      